/*
  HuCare — Section Swipe Groups
  ----------------------------------------------------------------------------
  Fasst mehrere gleichartige, direkt aufeinanderfolgende Sektionen zu EINEM
  swipebaren Splide-Karussell zusammen – ohne die Sektionen selbst zu verändern.

  Unterstützte Sektionen:
    • HuCare Comparison  -> erkannt an  ".hucare-cmp"
    • Flow               -> erkannt an  ".section-flow"

  Bedienung im Shop:
    Im Theme-Editor einfach mehrere Instanzen derselben Sektion direkt
    untereinander platzieren. Liegen 2+ gleiche Sektionen nebeneinander,
    werden sie automatisch zu einem Slider mit Pfeilen (links/rechts),
    Punkten und Touch-Swipe zusammengefasst. Eine einzelne Sektion bleibt
    unverändert.
*/
(function () {
  'use strict';

  // Erkennungsregeln je Sektionstyp. Reihenfolge = Priorität.
  var GROUPS = [
    { key: 'comparison', match: function (el) { return !!el.querySelector('.hucare-cmp'); } },
    { key: 'flow',       match: function (el) { return el.classList.contains('section-flow') || !!el.querySelector('.section-flow'); } }
  ];

  var PREV_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M15.5 19.5 8 12l7.5-7.5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var NEXT_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M8.5 4.5 16 12l-7.5 7.5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function groupKeyOf(section) {
    if (!section || section.nodeType !== 1 || !section.classList || !section.classList.contains('shopify-section')) {
      return null;
    }
    for (var i = 0; i < GROUPS.length; i++) {
      if (GROUPS[i].match(section)) return GROUPS[i].key;
    }
    return null;
  }

  // Bestehende HuCare-Slider auflösen und die echten Sektionen wieder
  // als normale Geschwister in den DOM zurücklegen (idempotenter Neuaufbau).
  function teardown() {
    var wraps = document.querySelectorAll('.hucare-swipe');
    for (var i = 0; i < wraps.length; i++) {
      var wrap = wraps[i];
      if (wrap._hucareSplide) {
        try { wrap._hucareSplide.destroy(true); } catch (e) {}
        wrap._hucareSplide = null;
      }
      var sections = wrap.querySelectorAll('.shopify-section');
      for (var j = 0; j < sections.length; j++) {
        wrap.parentNode.insertBefore(sections[j], wrap);
      }
      if (wrap.parentNode) wrap.parentNode.removeChild(wrap);
    }
  }

  // Aufeinanderfolgende, gleichartige Sektionen zu "runs" gruppieren.
  function findRuns() {
    var sections = document.querySelectorAll('.shopify-section');
    var runs = [];
    var handled = [];
    for (var i = 0; i < sections.length; i++) {
      var first = sections[i];
      if (handled.indexOf(first) !== -1) continue;
      var key = groupKeyOf(first);
      if (!key) continue;

      var run = [first];
      handled.push(first);
      var next = first.nextElementSibling;
      while (next && next.classList && next.classList.contains('shopify-section') && groupKeyOf(next) === key) {
        run.push(next);
        handled.push(next);
        next = next.nextElementSibling;
      }
      if (run.length >= 2) runs.push({ key: key, sections: run });
    }
    return runs;
  }

  function buildCarousel(run) {
    var first = run.sections[0];
    var parent = first.parentNode;
    if (!parent) return;

    var wrap = document.createElement('div');
    wrap.className = 'hucare-swipe splide';
    wrap.setAttribute('data-hucare-swipe', run.key);
    wrap.setAttribute('aria-roledescription', 'carousel');

    var track = document.createElement('div');
    track.className = 'splide__track';
    var list = document.createElement('div');
    list.className = 'splide__list';
    track.appendChild(list);
    wrap.appendChild(track);

    // Eigene Pfeile, damit Markup/SVG vollständig unter unserer Kontrolle sind.
    var arrows = document.createElement('div');
    arrows.className = 'splide__arrows hucare-swipe__arrows';
    arrows.innerHTML =
      '<button class="splide__arrow splide__arrow--prev hucare-swipe__arrow hucare-swipe__arrow--prev" type="button" aria-label="Zurück">' + PREV_SVG + '</button>' +
      '<button class="splide__arrow splide__arrow--next hucare-swipe__arrow hucare-swipe__arrow--next" type="button" aria-label="Weiter">' + NEXT_SVG + '</button>';
    wrap.appendChild(arrows);

    parent.insertBefore(wrap, first);

    for (var i = 0; i < run.sections.length; i++) {
      var slide = document.createElement('div');
      slide.className = 'splide__slide';
      slide.appendChild(run.sections[i]);
      list.appendChild(slide);
    }

    var splide = new Splide(wrap, {
      type: 'slide',
      rewind: true,
      rewindSpeed: 600,
      perPage: 1,
      perMove: 1,
      arrows: true,
      pagination: true,
      drag: true,
      speed: 450,
      autoHeight: true,
      slideFocus: false,
      i18n: { prev: 'Vorherige Sektion', next: 'Nächste Sektion' }
    });
    splide.mount();
    wrap._hucareSplide = splide;
  }

  function build() {
    if (typeof Splide === 'undefined') return false;
    teardown();
    var runs = findRuns();
    for (var i = 0; i < runs.length; i++) buildCarousel(runs[i]);
    return true;
  }

  // Splide wird per defer geladen; die Reihenfolge sollte passen, aber
  // zur Sicherheit kurz darauf warten.
  function boot() {
    if (build()) return;
    var tries = 0;
    var timer = setInterval(function () {
      tries++;
      if (build() || tries > 50) clearInterval(timer);
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // ---- Theme-Editor Unterstützung ----
  if (window.Shopify && window.Shopify.designMode) {
    var rebuildTimer = null;
    var scheduleRebuild = function () {
      clearTimeout(rebuildTimer);
      rebuildTimer = setTimeout(build, 150);
    };
    document.addEventListener('shopify:section:load', scheduleRebuild);
    document.addEventListener('shopify:section:unload', scheduleRebuild);
    document.addEventListener('shopify:section:reorder', scheduleRebuild);

    // Beim Auswählen einer Sektion im Editor zum passenden Slide springen.
    document.addEventListener('shopify:section:select', function (event) {
      var section = event.target;
      if (!section || !section.closest) return;
      var wrap = section.closest('.hucare-swipe');
      if (!wrap || !wrap._hucareSplide) return;
      var slide = section.closest('.splide__slide');
      if (!slide) return;
      var slides = wrap.querySelectorAll('.splide__list > .splide__slide');
      for (var i = 0; i < slides.length; i++) {
        if (slides[i] === slide) { wrap._hucareSplide.go(i); break; }
      }
    });
  }
})();
